(function($) {
    "use strict";

	jQuery(document).ready(function(){

	
      
    /* Match Heigh   
	$('.item').matchHeight();
    */
      
    

      

    /* Ajax Cart */
    $(".cart-item").on('click', function(){
      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },1000);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },1800);

    });
      
	/* wishlist */
    $(".action--wishlist").on('click', function(){
        $(this).addClass("loading-wishlist add-wishlist");
        setTimeout(function () {
          $(".action--wishlist").removeClass("loading-wishlist");
        },1000);
        setTimeout(function () {
          $(".add-wishlist").removeClass("add-wishlist");
        },1800);

     });

      
      
      
      
      
    });

})(jQuery);



